import React from 'react';
import PositionListItem from './PositionListItem';
import PropTypes from "prop-types";

export default class PositionGroup extends React.PureComponent {
	static propTypes={
		logoImage: PropTypes.node,
		positionList: PropTypes.array,
		language: PropTypes.string.isRequired,
		customerName: PropTypes.string.isRequired,
		agency: PropTypes.string
	}

	render(){
		let {positionList, logoImage,language,customerName,agency} = this.props;
			return (positionList.map((item, key) => {
				return (
					<PositionListItem
						language={language}
						customerLogoStyle={logoImage}
						position={item}
						customerName={customerName}
						agency={agency}
					/>
				);
			}));
	}
}
